import Comment from './Comment';

const CommentList = ({ data, canWrite = false }) => {
  if (!Array.isArray(data)) return null;

  const baseComments = data
    .filter((comment) => comment.parent === 0);

  const answerChildren = (list): any[] => {
    return (
      list
        .reverse()
        .map((comment, id) => (
          <Comment
            key={comment.id}
            data={comment}
            answers={null}
            keyId={`children.${id}`}
            canWrite={canWrite}
          />
        )) || []
    );
  };

  return (
    <>
      {baseComments
        // todo: pagination?
        .slice(0, 10)
        .map((comment, id: number) => (
          <Comment
            key={comment.id}
            data={comment}
            keyId={id}
            answers={answerChildren(
              data.filter((item) => item.parent === comment.id)
            )}
            canWrite={canWrite}
          />
        ))}
    </>
  );
};

export default CommentList;
